<style scoped>
.backIcon{
  background-color: rgb(4, 151, 255);
  border:none;
  box-shadow: none !important;
  margin-top:10px;
  height:2.5rem;
  color:#fff;
}
.searching .header_box .search_box .seachIpt{
  width:100%;
}
.searching .header_box .search_box .search_img{
  right:0%;
}
.searching .header_box .search_box{
  width:18.78rem;
}
.search_cancel{
    margin: 0.8rem 0.8rem;
    padding-left:1rem;
    font-size:1.1rem;
    color:#fff;
    height: 2.5rem;
    line-height: 2.5rem;
}
.seachIpt{
  margin:10px 5% 10px 0;
  padding-left: 5%;
  border-radius: 20px;
  background-color: #fff;
  height:2.5rem;
  line-height: 2.5rem;
  outline: none;
  border: none;
  width:85%;
}
</style>
<template>
  <div class="searching">
    <div class="header_box m_clearLR">
      <div class="m_floatL"><a @click="$router.go(-1)" slot="left">
          <mt-button class="backIcon" icon="back"></mt-button>
        </a></div>
      <div class="search_box m_floatL">
        <input
          type="text"
          class="seachIpt"
          @keyup.enter="searchSubmit"
          v-model="keyword"
          maxlength="20"
          :placeholder="keywordHolder"
        >
        <img src="./../assets/images/search.png" class="search_img">
      </div>
      <div class="search_cancel m_floatL" @click="searchSubmit">确定</div>
    </div>
    <div class="search_list_box">
      <div class="m_clearLR search_div">
        <div class="m_floatL search_title">使用教程</div>
      </div>
    </div>
    <div class="m_pointMsg" v-show="jc_msgShow">无相关内容</div>
    <div class="goods_box m_clearLR">
      <div
        class="goods_div m_floatL"
        @click="toTuInfo(item.id)"
        v-for="(item,index) in list"
        :key="index"
      >
        <div class="goods_img">
          <img :src="item.preview">
        </div>
        <div>{{item.title}}</div>
      </div>
    </div>
    <div class="search_more" v-show="isMoretutorial" @click="toMoretutorial">查看更多</div>
    <div class="search_list_box">
      <div class="m_clearLR search_div">
        <div class="m_floatL search_title">故障排除</div>
      </div>
    </div>
    <div class="m_pointMsg" v-show="gz_msgShow">无相关内容</div>
    <div class="goods_box m_clearLR">
      <div
        class="goods_divTwo"
        @click="toTtInfo(item.id)"
        v-for="(item,index) in list2"
        :key="index"
      >
        <div>{{item.title}}</div>
        <div class="m_clearLR goods_msg_box">
          <div class="m_floatL">{{item.views?item.views:'0'}}人阅读</div>
          <div class="m_floatL createdTime">{{item.created_at|partFilter}}</div>
        </div>
      </div>
    </div>
    <div class="search_more" v-show="isTrouble" @click="toMoreTrouble">查看更多</div>
  </div>
</template>

<script>
import { getKeywords, getArticle } from '@/api/api'
export default {
  data () {
    return {
      list: [],
      num: 3,
      list2: [],
      isMoretutorial: false,
      isTrouble: false,
      flag: false,
      gz_msgShow: false,
      jc_msgShow: false,
      keywordHolder: '佳博GP1324D打印机',
      keyword: '',
      testImg:
        'http://47.106.192.126/media/images/goods/goods_front_image/2018/09/TB229W7jOMnBKNjSZFCXXX0KFXa_931936555.jpg_800x800q90.jpg'
    }
  },
  created () {
    // setTimeout(() => {
    //   getKeywords().then((res)=>{
    //      console.log(res.data)
    //     for(var i = 0 ; i < res.data.length ; i ++){
    //       if(res.data[i].use){
    //         this.keyword = res.data[i].keywordsId[0].value
    //         break
    //       }
    //     }
    //   })
    //   this.getList();
    // }, 500);
    this.keywordHolder = localStorage.getItem('searchWord')
    this.getList()
  },
  filters: {
    // 转化时间年月日
    partFilter: function (value, type) {
      if (!value) return ''
      var time = value.split('T')[0]
      var year = time.split('-')
      value = year[0] + '年' + year[1] + '月' + year[2] + '日'
      return value
    }
  },
  methods: {
    toTuInfo (id) {
      this.$router.push({ path: '/tutorialDownInfo', query: { id: id } })
    },
    toTtInfo (id) {
      this.$router.push({ path: '/troubleshootingInfo', query: { id: id } })
    },
    searchCancel () {},
    toMoretutorial () {
      this.$router.push({
        path: '/moreTutorial',
        query: { keyword: this.keyword }
      })
    },
    toMoreTrouble () {
      this.$router.push({
        path: '/moreTroubleshooting',
        query: { keyword: this.keyword }
      })
    },
    searchSubmit () {
      this.getList()
    },
    getList () {
      var tempKeyword = this.keyword

      if (this.falg) {
        return
      }
      this.flag = true
      if (!this.keyword) tempKeyword = this.keywordHolder
      if (document.querySelector('.loadmore_box')) { document.querySelector('.loadmore_box').scrollTop = 0 }

      getArticle('?search=' + tempKeyword).then(res => {
        this.list = []
        this.list2 = []
        var data = res.data.results
        var gz_flag = false,
          jc_flag = false
        for (var i = 0; i < data.length; i++) {
          if (data[i].article_type == 1 && this.list.length < 3) {
            this.list.push(data[i])
            jc_flag = true
          } else if (data[i].article_type == 2 && this.list2.length < 3) {
            this.list2.push(data[i])
            gz_flag = true
          }
        }
        if (this.list.length >= 3) {
          this.isMoretutorial = true
        } else {
          this.isMoretutorial = false
        }
        if (this.list2.length >= 3) {
          this.isTrouble = true
        } else {
          this.isTrouble = false
        }
        this.flag = false
        if (gz_flag == false) {
          this.gz_msgShow = true
        } else {
          this.gz_msgShow = false
        }
        if (jc_flag == false) {
          this.jc_msgShow = true
        } else {
          this.jc_msgShow = false
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/searching.vue